import { useEffect } from "react";
import { useDispatch } from 'react-redux'
import { Form, Input, Button, Select, Tooltip } from "antd";
import { BiInfoCircle } from 'react-icons/bi'
import styled from "styled-components";

import Actions from "../../redux/actions";
import Service from '../../service/mgt-sensor-data';
import FormControl from "../../component/form/FormControl";

import moment from "moment";
import "moment/locale/th";
moment.locale("th");


const FormExtend = styled(FormControl)`
  display: flex;
  flex-wrap: wrap;
  border-radius: 99px;

  .form-item__eval-pattern{
    width: 100%;
  }
`;

export default function FormMgtSensorData(props) {
  const [form] = Form.useForm();
  const dispatch = useDispatch()

  useEffect(() => {
    const init = async () => {
      if (props.data) {
        form.setFieldsValue({
          rawData : props.data.raw_data,
          procData: props.data.proc_data,
        })
      }
    }
    init()
  }, [form])

  const onFinish = async (values) => {
      let result = await Service.update(props.data.id, values)
      if(result){
        dispatch(Actions.MgtSensorData.updateData(result))
        dispatch(Actions.popup.toggleVisible(false))
      }
  }

  const formInput = () => {
    return (
      <>
        <Form.Item
          name={["rawData"]}
          className="form-item__raw-data"
          label="ระดับน้ำจากสถานี"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" onChange={(e) => {
            let value = e.target.value.replace(/[^0-9.]+/g, "");
            form.setFieldsValue({ rawData: value });
          }}/>
        </Form.Item>
        <Form.Item
          name={["procData"]}
          className="form-item__proc-data"
          label="ข้อมูล"
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" onChange={(e) => {
            let value = e.target.value.replace(/[^0-9.]+/g, "");
            form.setFieldsValue({ procData: value });
          }}/>
        </Form.Item>
        <Form.Item className="form-button">
        {props.permission.indexOf('update') >= 0 ? (<Button className="form-item__btn-submit btn-primary" htmlType="submit">{'อัพเดทข้อมูล'}</Button>) : (<></>)}
          <Button className="form-item__btn-cancel btn-secondary"
           onClick={() => dispatch(Actions.popup.toggleVisible(false))}
          >
            ยกเลิก
          </Button>
        </Form.Item>
      </>
    );
  };

  return (
    <FormExtend
      name={"form-mgt__sensor-data"}
      column={2}
      inputs={formInput}
      onFinish={props.onFinish ? props.onFinish : onFinish}
      form={form}
      className={props.className ? props.className : ""}
    />
  );
}
